import { useEffect, useState, type ReactNode } from 'react';
import { useDispatch } from 'react-redux';
import { useUserContext } from '@fff-web/fff-utilities';
import { receiveUserRole } from '../../pages/MyAccount/services/actions/userActions';

/**
 * Keeps Redux `user.role` in step with menu-data's `role` (derived in asado from growth +
 * membership), which replaced the `/users/self/accounts` one. Children render only once the role
 * is in the store, so pages that branch on it at mount (e.g. `isClubMember`) never see it unset.
 */
export const UserRoleSync = ({ children }: { children: ReactNode }) => {
  const dispatch = useDispatch();
  const { userInfo } = useUserContext();
  const role = userInfo?.user?.role || null;
  const [syncedRole, setSyncedRole] = useState<string | null | undefined>(undefined);

  useEffect(() => {
    dispatch(receiveUserRole(role));
    setSyncedRole(role);
  }, [dispatch, role]);

  return syncedRole === undefined ? null : <>{children}</>;
};

export default UserRoleSync;
